export enum AppMode {
    Home = 'home',
    Edit = 'edit',
    Preview = 'preview',
}
